import {useState} from 'react'
import {BackdropContext} from './BackdropContext'

const style = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(2px)',
  padding: '20px',
  height: '100%',
  width: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 100
}

export const Backdrop = ({children}) => {
  const [visible, setVisible] = useState(false)

  return (
    <BackdropContext.Provider value={{visible, setVisible}}>
      {visible && <div style={style} />}
      {children}
    </BackdropContext.Provider>
  )
}
